import { useRoutes } from 'react-router-dom';
import routes from './Routes';

const Routing = () => {
    const Router = useRoutes(routes);
    return Router
}

export default Routing